<template lang="pug">
  div
    ListExceptionsOV
</template>

<script>
import ListExceptionsOV from '../components/OV/ListExceptionsOV.vue'

export default {
  name: 'ExceptionsOV',
  components: {
    ListExceptionsOV,
  },
  data() {
    return {
      isModalVisible: false,
    }
  },
}
</script>

<style lang="scss" scoped>
.btn-new-ov {
  background-color: #fece2f;
  border: none;
  color: black;
}
.back-arrow {
  margin: 2px 25px 7px 0px;
  cursor: pointer;
  color: #fece2f;
}
</style>
